module.exports = __webpack_public_path__ + "img/image-icon-pan.e940b26f.svg";